import { Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "./routing/ProtectedRoute";
import PublicRoute from "./routing/PublicRoute";
import SuperAdminRoute from "./routing/SuperAdminRoute";

import DashboardPage from "./pages/DashboardPage";
import LeadsPage from "./pages/Leads";
import MailsPage from "./pages/MailsPage";
import UnassignedHubPage, { WhatsAppConnectRedirect } from "./pages/UnassignedHubPage";
import DatabasePage from "./pages/DatabasePage";
import BulkValidationPage from "./pages/BulkValidationPage";
import EmailVerificationPage from "./pages/EmailVerificationPage";

import LoginScreen from "./pages/auth/LoginScreen";
import VerifyEmailPage from "./pages/auth/signup/VerifyEmailPage";
import ConfirmEmailPage from "./pages/auth/signup/ConfirmEmailPage";
import CreateAccountPage from "./pages/auth/signup/CreateAccountPage";
import SignupPlanPage from "./pages/auth/signup/SignupPlanPage";
import OAuthCallback from "./pages/auth/OAuthCallback";
import ComponentGallery from "./pages/dev/ComponentGallery";
import RecoverPassword from "./pages/auth/RecoverPasswordPage";
import AdminPage from "./pages/AdminPage";
import AdminUsuariosPage from "./pages/AdminUsuariosPage";
import TemplatesHubPage, { WhatsAppTemplatesRedirect } from "./pages/TemplatesHubPage";

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/dev/ui" element={<ComponentGallery />} />
      <Route element={<PublicRoute />}>
        <Route path="/login" element={<LoginScreen />} />
        <Route path="/signup/verify-email" element={<VerifyEmailPage />} />
        <Route path="/recover-password" element={<RecoverPassword />} />
        <Route
          path="/recover-password/:uid/:token"
          element={<RecoverPassword />}
        />
      </Route>

      <Route path="/confirm-email/:uid/:token" element={<ConfirmEmailPage />} />
      <Route path="/oauth/callback/google" element={<OAuthCallback />} />
      <Route path="/oauth/callback/microsoft" element={<OAuthCallback />} />

      <Route element={<SuperAdminRoute />}>
        <Route path="/admin/cuentas" element={<AdminPage />} />
        <Route path="/admin/usuarios" element={<AdminUsuariosPage />} />
      </Route>

      <Route element={<ProtectedRoute />}>
        <Route path="/signup/create-account" element={<CreateAccountPage />} />
        <Route path="/signup/plan" element={<SignupPlanPage />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/leads" element={<LeadsPage />} />
        <Route path="/leads/:id" element={<LeadsPage />} />
        <Route path="/mails" element={<MailsPage />} />
        <Route path="/sin-asignar" element={<UnassignedHubPage />} />
        <Route path="/templates" element={<TemplatesHubPage />} />
        <Route path="/database" element={<DatabasePage />} />
        <Route path="/database/bulk/:taskId" element={<BulkValidationPage />} />
        <Route
          path="/database/verification/:taskId"
          element={<EmailVerificationPage />}
        />
        <Route path="/whatsapp/connect" element={<WhatsAppConnectRedirect />} />
        <Route path="/whatsapp/plantillas" element={<WhatsAppTemplatesRedirect />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Route>

      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}
